import React, { useState, useEffect, useMemo } from "react";
import Form from "react-bootstrap/Form";
import { ToastProvider, useToast } from "../common/RemitAssureToast";
import "react-phone-input-2/lib/bootstrap.css";
import { useFormik } from "formik";
import countryOptions from "../../utils/AllCountryList";
import * as Yup from "yup";
import clsx from "clsx";
import {
  userProfile,
  updateProfile,
  updateAccountUsage,
  getCurrencies,
  resendOtp,
} from "../../utils/Api";
import { Button, FormSelect, Modal } from "react-bootstrap";
import PopVerify from "../verification/PopVerify";
import { senderAreaList as areaList } from "../../utils/ArealList";
import Autocomplete from "react-google-autocomplete";
import { BsCheckCircleFill } from "react-icons/bs";
import {
  inputValidator,
  getSelectedStreet,
  accessProvider,
} from "../../hooks/validator";
import limits from "../../hooks/limitations";
import { FaPhoneAlt, FaEnvelope } from "react-icons/fa";
import allCountries from "../../utils/AllCountryList";
import Select from "react-select";

const Profile = () => {
  const [account_type, setAccountType] = useState(() => {
    if (sessionStorage.getItem("remi-user-dt")) {
      const v = JSON.parse(sessionStorage.getItem("remi-user-dt"));
      return v.account_type;
    } else {
      return { account_type: "individual" };
    }
  });

  const [open_modal, setOpenModal] = useState(false);
  const [is_otp_verified, setIsOtpVerfied] = useState(false);
  const [loading, setLoading] = React.useState(false);
  const [is_update, setIsUpdate] = useState({ email: "", mobile: "" });
  const [account_usage_updater, setAccountUsageUpdater] = useState({
    is_open: false,
    type: null,
    value: null,
  });
  const [middle_name_optional, setMiddleNameOptional] = useState(false);
  const [ubo_middle_name_optional, setUboMiddleNameOptional] = useState(false);
  const [showOtpPopup, setShowOtpPopup] = useState(false);
  const [selectedOtpOption, setSelectedOtpOption] = useState("mobile");
  const [profileUpdateData, setProfileUpdateData] = useState({});
  const [selected_area_code, setSelectedAreaCode] = useState("61");
  const [user_data, setUserData] = useState();
  const [max_date, setMaxDate] = useState("");
  const [min_date, setMinDate] = useState("");
  const [ubo_area_code, setUboAreaCode] = useState("61");
  const [verification_status, setVerificationStatus] = useState("pending");
  const [duplicate_detail, setDuplicateDetail] = useState(false);
  const [countries, setCountries] = useState([]);
  const [phoneCountries, setPhoneCountries] = useState([]);
  const { showToast } = useToast();
  const [selectedCountryOfBirth, setSelectedCountryOfBirth] = useState(null);
  const [selectedUboCountryOfBirth, setSelectedUboCountryOfBirth] =
    useState(null);
  const [selectedRegistrationCountry, setSelectedRegistrationCountry] =
    useState(null);
  const [selectedCountry, setSelectedCountry] = useState(null);

  const isProfileCompleted =
    user_data?.profile_completed === true ||
    user_data?.profile_completed === "true" ||
    user_data?.profile_completed === "True";
  const isAdminOnboardedProfileIncomplete =
    user_data?.is_digital_Id_verified?.toLowerCase() === "approved" &&
    !isProfileCompleted;
  const isFieldsLocked =
    verification_status === "approved" && !isAdminOnboardedProfileIncomplete;

  // Format country options for react-select
  const countrySelectOptions = useMemo(() => {
    if (!countryOptions || countryOptions.length === 0) return [];
    return countryOptions.map((country) => ({
      value: country.name,
      label: country.name,
      code: country.code,
    }));
  }, [countryOptions]);

  // Format countries for react-select (from API)
  const apiCountrySelectOptions = useMemo(() => {
    if (!countries || countries.length === 0) return [];
    return countries.map((country) => ({
      value: country.country,
      label: country.country,
      code: country.country_code,
      phone_code: country.phone_code,
    }));
  }, [countries]);

  const initialValues = {
    business_name: "",
    business_nature: "",
    business_address: "",
    registration_date: "",
    registration_number: "",
    registration_country: "",
    ubo_first_name: "",
    ubo_middle_name: "",
    ubo_last_name: "",
    ubo_email: "",
    ubo_mobile: "",
    ubo_date_of_birth: "",
    ubo_occupation: "",
    ubo_country_of_birth: "",
    First_name: "",
    Middle_name: "",
    Last_name: "",
    Gender: "Male",
    Country_of_birth: "",
    Date_of_birth: "",
    flat: "",
    building: "",
    street: "",
    city: "",
    country: "none",
    country_code: "AU",
    postcode: "",
    state: "",
    email: "",
    mobile: "",
    occupation: "",
    address: "",
    customer_id: "",
    payment_per_annum: "Tier-1 Less than 5 times",
    value_per_annum: "Tier-1 Less than $30,000",
  };

  // yup validator for data handling
  const profileSchema = useMemo(
    () =>
      Yup.object().shape({
        business_name:
          account_type == "business"
            ? Yup.string()
                .min(limits.business_name.min)
                .max(limits.business_name.max)
                .required()
                .trim()
            : Yup.string().notRequired(),
        business_nature:
          account_type == "business"
            ? Yup.string()
                .min(limits.business_nature.min)
                .max(limits.business_nature.max)
                .required("Business Nature is required")
                .trim()
            : Yup.string().notRequired(),
        registration_number:
          account_type == "business"
            ? Yup.string()
                .min(limits.registration_number.min)
                .max(limits.registration_number.max)
                .required("Registration Number is required")
                .trim()
            : Yup.string().notRequired(),
        registration_date:
          account_type === "business"
            ? Yup.string()
                .matches(
                  /^\d{4}-\d{2}-\d{2}$/,
                  "Invalid date format (YYYY-MM-DD required)",
                )
                .test(
                  "valid-date-range",
                  "Date must be within the last 200 years and not in the future",
                  (value) => {
                    if (!value) return false;
                    const date = new Date(value);
                    if (isNaN(date.getTime())) return false;
                    const today = new Date();
                    const minDate = new Date();
                    minDate.setFullYear(today.getFullYear() - 200);
                    return date >= minDate && date <= today;
                  },
                )
                .required("Registration date is required")
            : Yup.string().notRequired(),
        registration_country:
          account_type == "business"
            ? Yup.string()
                .max(limits.country)
                .required("Registration Country is required")
                .trim()
            : Yup.string().notRequired(),
        business_address:
          account_type == "business"
            ? Yup.string()
                .max(limits.address)
                .required("Business Address is required")
                .trim()
            : Yup.string().notRequired(),
        ubo_first_name:
          account_type == "business"
            ? Yup.string().max(limits.name).required().trim()
            : Yup.string().notRequired(),
        ubo_middle_name:
          account_type == "business"
            ? ubo_middle_name_optional
              ? Yup.string().max(limits.name).trim().notRequired()
              : Yup.string()
                  .max(limits.name)
                  .required("Middle Name is required")
                  .trim()
            : Yup.string().notRequired(),
        ubo_last_name:
          account_type == "business"
            ? Yup.string().max(limits.name).required().trim()
            : Yup.string().notRequired(),
        ubo_email:
          account_type == "business"
            ? Yup.string()
                .matches(
                  /^[\w-+\.]+@([\w-]+\.)+[\w-]{2,5}$/,
                  "Invalid email format",
                )
                .min(limits.email.min)
                .max(limits.email.max)
                .required()
            : Yup.string().notRequired(),
        ubo_mobile:
          account_type === "business"
            ? Yup.string()
                .label("UBO Mobile")
                .required("Mobile is required")
                .matches(/^[0-9]+$/, "Invalid mobile number")
                .test(
                  "length-check",
                  "Mobile must be 9–10 digits (excluding leading zeros)",
                  function (value) {
                    if (!value) return false;
                    const cleaned = value.replace(/^0+/, "");
                    if (cleaned.length < limits.user_mobile.min) {
                      return this.createError({
                        message: `Mobile must be at least ${limits.user_mobile.min} digits`,
                      });
                    }
                    if (cleaned.length > limits.user_mobile.max) {
                      return this.createError({
                        message: `Mobile must be at most ${limits.user_mobile.max} digits`,
                      });
                    }
                    return true;
                  },
                )
            : Yup.string().notRequired(),
        ubo_date_of_birth:
          account_type == "business"
            ? Yup.string()
                .matches(
                  /^\d{4}-\d{2}-\d{2}$/,
                  "Invalid date format (YYYY-MM-DD required)",
                )
                .test("valid-year-range", "Invalid Date", (value) => {
                  if (!value) return false;
                  const year = parseInt(value.split("-")[0], 10);
                  const currentYear = new Date().getFullYear();
                  const minYear = currentYear - 100;
                  const maxYear = currentYear - 18;
                  return year >= minYear && year <= maxYear;
                })
                .required("Date of Birth is required")
            : Yup.date().notRequired(),
        ubo_occupation:
          account_type == "business"
            ? Yup.string().min(1).max(limits.occupation).required().trim()
            : Yup.string().notRequired(),
        ubo_country_of_birth:
          account_type == "business"
            ? Yup.string().required("Country of Birth is required")
            : Yup.string().notRequired(),
        First_name: Yup.string().max(limits.name).required().trim(),
        Last_name: Yup.string().max(limits.name).required().trim(),
        Middle_name: middle_name_optional
          ? Yup.string().max(limits.name).trim().notRequired()
          : Yup.string()
              .max(limits.name)
              .required("Middle Name is required")
              .trim(),
        email: Yup.string()
          .matches(/^[\w-+\.]+@([\w-]+\.)+[\w-]{2,5}$/, "Invalid email format")
          .min(limits.email.min)
          .max(limits.email.max)
          .required(),
        mobile: Yup.string()
          .label("Mobile")
          .required("Mobile is required")
          .test("valid-mobile", "Invalid mobile number", function (value) {
            if (!value) return false;
            if (!/^[0-9]+$/.test(value)) {
              return this.createError({ message: "Invalid mobile number" });
            }
            const cleaned = value.replace(/^0+/, "");
            if (cleaned.length < limits.user_mobile.min) {
              return this.createError({
                message: `Mobile must be at least ${limits.user_mobile.min} digits`,
              });
            }
            if (cleaned.length > limits.user_mobile.max) {
              return this.createError({
                message: `Mobile must be at most ${limits.user_mobile.max} digits`,
              });
            }
            return true;
          }),
        address: Yup.string(),
        flat: Yup.string().max(limits.flat).trim().notRequired(),
        building: Yup.string().max(limits.building).required().trim(),
        street: Yup.string().max(limits.street).required().trim(),
        city: Yup.string().max(limits.city).required().trim(),
        postcode: Yup.string()
          .min(
            limits.user_zip.min,
            `Postcode must be at least ${limits.user_zip.min} digits`,
          )
          .max(
            limits.user_zip.max,
            `Postcode cannot be more than ${limits.user_zip.max} digits`,
          )
          .matches(
            /^[A-Za-z0-9-]+$/,
            "Postcode must contain only letters, numbers, or hyphen",
          )
          .required("Postcode is required"),
        state: Yup.string().max(limits.state).required().trim(),
        country: Yup.string().max(limits.country).required().notOneOf(["none"]),
        Date_of_birth: Yup.date()
          .min(new Date(Date.now() - 3721248000000), "Invalid Date")
          .max(new Date(Date.now() - 567648000000), "Invalid Date")
          .required("DOB is required"),
        occupation: Yup.string().max(limits.occupation).required().trim(),
        Country_of_birth: Yup.string().required("Country of Birth is required"),
        payment_per_annum: Yup.string().required(),
        value_per_annum: Yup.string().required(),
      }),
    [account_type, middle_name_optional, ubo_middle_name_optional],
  );

  useEffect(() => {
    if (duplicate_detail) {
      setUboMiddleNameOptional(middle_name_optional);
    }
  }, [duplicate_detail, middle_name_optional]);

  useEffect(() => {
    formik.validateForm();
  }, [middle_name_optional, ubo_middle_name_optional, duplicate_detail]);

  useEffect(() => {
    const fetchCurrencies = async () => {
      try {
        const response = await getCurrencies();
        if (response?.code === "200" && response?.data?.payin_currencies) {
          const { payin_currencies } = response.data;
          setCountries(payin_currencies);
          const sortedCountries = payin_currencies.sort((a, b) =>
            a.country.localeCompare(b.country),
          );
          setPhoneCountries(sortedCountries);
          const token = sessionStorage.getItem("token");
          const user = sessionStorage.getItem("remi-user-dt");
          if (!!token && !!user) {
            fetchProfile(sortedCountries);
          }
        }
      } catch (error) {
        console.error("Error fetching countries:", error);
        setCountries([]);
        setPhoneCountries([]);
      }
    };

    fetchCurrencies();
  }, []);

  const handleOtpVerification = (value) => {
    setIsOtpVerfied(value);
  };

  const getCountryCode = (countryName) => {
    return (
      allCountries.find((country) => {
        return countryName === country.name;
      })?.code || "au"
    );
  };

  const getBusinessCountryCode = (countryName) => {
    return (
      allCountries.find((country) => {
        return countryName === country.name;
      })?.code || "au"
    );
  };

  // formik instance to handle form
  const formik = useFormik({
    initialValues,
    validationSchema: profileSchema,
    onSubmit: async (values) => {
      if (values.country === "Australia") {
        values.country_code = "AU";
      } else {
        values.country_code = "NZ";
      }

      // Store the form data and show OTP popup instead of directly opening modal
      let payload = { ...values };
      payload.mobile = "+" + selected_area_code + parseInt(payload.mobile, 10);
      if (payload.ubo_mobile) {
        payload.ubo_mobile =
          "+" + ubo_area_code + parseInt(payload.ubo_mobile, 10);
      }
      payload.country_code = payload.country_code;
      payload.location = payload.country;
      payload.Gender = "NA";

      // Store the prepared payload
      setProfileUpdateData(payload);
      setShowOtpPopup(true);
    },
  });

  const handleOtpPopupContinue = () => {
    setLoading(true);

    // Get user data from session storage
    const userData = JSON.parse(sessionStorage.getItem("remi-user-dt"));

    // Prepare payload for sendOtpMethod API
    let otpPayload = {
      otp_type: selectedOtpOption,
    };

    // Add email and mobile to payload - include both from user data
    otpPayload.email = userData?.email || "";
    otpPayload.mobile = userData?.mobile || userData?.phone || "";

    // Call sendOtpMethod API
    resendOtp(otpPayload)
      .then((response) => {
        setLoading(false);
        if (response.code === "200" || response.code === 200) {
          showToast(
            "success",
            "Success",
            response.message || "OTP sent successfully",
          );
          setShowOtpPopup(false);
          setOpenModal(true); // This will open the existing OTP verification modal
        } else {
          showToast("error", "Error", response.message || "Failed to send OTP");
        }
      })
      .catch((error) => {
        setLoading(false);
        showToast("error", "Error", error.message || "Error sending OTP");
      });
  };

  const fetchProfile = async (phoneCountriesParam = phoneCountries) => {
    setLoading(true);
    const response = await userProfile();
    setLoading(false);

    if (response) {
      if (response.code === "200") {
        const { data } = response;

        // IMPROVED Phone Code Extraction Function for your specific phone codes
        const extractPhoneDetails = (
          mobileNumber,
          phoneCountriesParam,
          defaultCode = "61",
        ) => {
          if (
            !mobileNumber ||
            !mobileNumber.startsWith("+") ||
            phoneCountriesParam.length === 0
          ) {
            return { phoneCode: defaultCode, phoneNumber: mobileNumber || "" };
          }

          const mobileWithoutPlus = mobileNumber.substring(1);

          // Sort phone countries by code length (longest first) for better matching
          const sortedPhoneCountries = [...phoneCountriesParam].sort(
            (a, b) =>
              b.phone_code.toString().length - a.phone_code.toString().length,
          );

          // Try to match against all available phone codes
          for (const country of sortedPhoneCountries) {
            const phoneCodeStr = country.phone_code.toString();
            if (mobileWithoutPlus.startsWith(phoneCodeStr)) {
              const extractedNumber = mobileWithoutPlus.substring(
                phoneCodeStr.length,
              );
              return {
                phoneCode: phoneCodeStr,
                phoneNumber: extractedNumber,
              };
            }
          }
          // Final fallback: return original number without + and default code
          return { phoneCode: defaultCode, phoneNumber: mobileWithoutPlus };
        };

        const { phoneCode: extractedPhoneCode, phoneNumber } =
          extractPhoneDetails(data.mobile, phoneCountriesParam, "61");
        setSelectedAreaCode(extractedPhoneCode);

        let uboExtractedPhoneCode = "61";
        let uboPhoneNumber = "";

        if (data.ubo_mobile && data.ubo_mobile !== null) {
          const uboDetails = extractPhoneDetails(
            data.ubo_mobile,
            phoneCountriesParam,
            "61",
          );
          uboExtractedPhoneCode = uboDetails.phoneCode;
          uboPhoneNumber = uboDetails.phoneNumber;
        }
        setUboAreaCode(uboExtractedPhoneCode);

        let p_a = "Tier-1 Less than 5 times",
          v_a = "Tier-1 Less than $30,000";
        if (data.payment_per_annum !== "" && data.payment_per_annum !== null) {
          p_a = data.payment_per_annum;
        }
        if (data.value_per_annum !== "" && data.value_per_annum !== null) {
          v_a = data.value_per_annum;
        }
        if (data.account_type) {
          setAccountType(data?.account_type);
        }

        // Set selected country values for react-select
        if (data?.Country_of_birth && data.Country_of_birth !== "none") {
          setSelectedCountryOfBirth({
            value: data.Country_of_birth,
            label: data.Country_of_birth,
          });
        }

        if (
          data?.ubo_country_of_birth &&
          data.ubo_country_of_birth !== "none"
        ) {
          setSelectedUboCountryOfBirth({
            value: data.ubo_country_of_birth,
            label: data.ubo_country_of_birth,
          });
        }

        if (
          data?.registration_country &&
          data.registration_country !== "none"
        ) {
          setSelectedRegistrationCountry({
            value: data.registration_country,
            label: data.registration_country,
          });
        }

        if (data?.location && data.location !== "none") {
          setSelectedCountry({
            value: data.location,
            label: data.location,
          });
        }

        formik.setValues({
          ...formik.values,
          ...data,
          country: data?.location,
          mobile: phoneNumber,
          ubo_mobile: uboPhoneNumber,
          postcode: data.postcode,
          state:
            data?.state !== null && data?.state !== "none" ? data?.state : "",
          city: data?.city !== null && data?.city !== "none" ? data?.city : "",
          occupation:
            data?.occupation?.toLowerCase() !== "none" ? data?.occupation : "",
          payment_per_annum: p_a,
          value_per_annum: v_a,
          address: data.address != null ? data?.address : "",
        });

        setIsUpdate({ email: data.email, mobile: data.mobile });
        setUserData(data);
        setDuplicateDetail(data?.is_checked);
        setMiddleNameOptional(
          data?.middle_name_check === "True" ||
            data?.middle_name_check === true,
        );
        setUboMiddleNameOptional(
          data?.ubo_middle_name_check === "True" ||
            data?.ubo_middle_name_check === true,
        );
        setVerificationStatus(
          accessProvider(
            data?.is_digital_Id_verified?.toLowerCase(),
            data?.veriff_status?.toLowerCase(),
          ).status,
        );
      } else {
        showToast("error", "Error", response?.message || "Unable to fetch.");
      }
    }
  };

  useEffect(() => {
    const today = new Date();
    const pad = (n) => (n < 10 ? "0" + n : n);
    let day =
      today.getMonth() === 1 && today.getDate() === 29 ? 28 : today.getDate();
    const month = pad(today.getMonth() + 1);
    const dayStr = pad(day);
    const year = today.getFullYear();
    const maxDate = `${year - 18}-${month}-${dayStr}`;
    const minDate = `${year - 100}-${month}-${dayStr}`;
    const maxregDate = today.toISOString().split("T")[0];
    const minregDate = new Date(
      today.getFullYear() - 200,
      today.getMonth(),
      today.getDate(),
    )
      .toISOString()
      .split("T")[0];
    setMinDate(minDate);
    setMaxDate(maxDate);
    const setInputDateLimits = (id, min, max) => {
      const el = document.getElementById(id);
      if (el) {
        el.setAttribute("min", min);
        el.setAttribute("max", max);
      }
    };
    setInputDateLimits("ubo_dob", minDate, maxDate);
    setInputDateLimits("registration_date", minregDate, maxregDate);
  }, []);

  // handle fields changed due to country change
  const countryHandler = (selectedOption) => {
    setSelectedCountry(selectedOption);
    formik.setFieldValue("country", selectedOption ? selectedOption.value : "");
    formik.setFieldTouched("country", true, false);
    formik.setValues({
      ...formik.values,
      country: selectedOption ? selectedOption.value : "",
      state: "",
      city: "",
      street: "",
    });
  };

  const handleCountryOfBirthChange = (selectedOption) => {
    setSelectedCountryOfBirth(selectedOption);
    formik.setFieldValue(
      "Country_of_birth",
      selectedOption ? selectedOption.value : "",
    );
    formik.setFieldTouched("Country_of_birth", true, false);

    if (duplicate_detail) {
      setSelectedUboCountryOfBirth(selectedOption);
      formik.setFieldValue(
        "ubo_country_of_birth",
        selectedOption ? selectedOption.value : "",
      );
      formik.setFieldTouched("ubo_country_of_birth", true, false);
    }
  };

  const handleUboCountryOfBirthChange = (selectedOption) => {
    setSelectedUboCountryOfBirth(selectedOption);
    formik.setFieldValue(
      "ubo_country_of_birth",
      selectedOption ? selectedOption.value : "",
    );
    formik.setFieldTouched("ubo_country_of_birth", true, false);
  };

  const handleRegistrationCountryChange = (selectedOption) => {
    setSelectedRegistrationCountry(selectedOption);
    formik.setFieldValue(
      "registration_country",
      selectedOption ? selectedOption.value : "",
    );
    formik.setFieldTouched("registration_country", true, false);
  };

  const handleSubmit = async () => {
    let payload = { ...profileUpdateData };

    const isEmpty = (val) =>
      val === "" ||
      val === undefined ||
      val === null ||
      (typeof val === "string" && val.trim() === "");
    const optionalFormikFields = ["flat", "address"];

    if (middle_name_optional || !formik.values.Middle_name) {
      delete payload["Middle_name"];
    }
    if (ubo_middle_name_optional || !formik.values.ubo_middle_name) {
      delete payload["ubo_middle_name"];
    }
    optionalFormikFields.forEach((key) => {
      if (isEmpty(payload[key])) {
        delete payload[key];
      }
    });

    if (is_update.email === payload.email) {
      delete payload.email;
    }
    if (is_update.mobile === payload.mobile) {
      delete payload.mobile;
    }
    if (payload?.new_mobile?.length <= 4) {
      delete payload.new_mobile;
    }

    let fieldsToDelete = [
      "customer_id",
      "stripe_customer_id",
      "referred_by",
      "referral_code",
      "mobile_verified",
      "is_verified",
      "is_digital_Id_verified",
      "destination_currency",
      "created_at",
      "profile_completed",
      "value_per_annum",
      "payment_per_annum",
      "documents",
      "account_type",
    ];

    if (account_type !== "business") {
      fieldsToDelete.push(
        "business_name",
        "business_nature",
        "registration_date",
        "business_address",
        "registration_number",
        "registration_country",
        "ubo_first_name",
        "ubo_country_of_birth",
        "ubo_date_of_birth",
        "ubo_email",
        "ubo_last_name",
        "ubo_middle_name",
        "ubo_mobile",
        "ubo_occupation",
      );
    }

    for (const key of fieldsToDelete) {
      delete payload[key];
    }

    if (duplicate_detail) {
      payload.is_checked = true;
    } else {
      payload.is_checked = false;
    }
    payload.middle_name_check = middle_name_optional ? "True" : "False";
    payload.ubo_middle_name_check = ubo_middle_name_optional ? "True" : "False";
    setLoading(true);
    const response = await updateProfile(payload);
    setLoading(false);

    if (response) {
      if (response.code === "200") {
        let user = JSON.parse(sessionStorage.getItem("remi-user-dt"));
        if (user) {
          sessionStorage.removeItem("remi-user-dt");
          sessionStorage.setItem(
            "remi-user-dt",
            JSON.stringify({
              ...response?.data,
              is_digital_Id_verified: user?.is_digital_Id_verified,
              account_type: account_type,
            }),
          );
        }
        showToast("success", "Success", "Profile updated successfully");
        formik.resetForm();
        fetchProfile(phoneCountries);
      } else {
        showToast("error", "Error", response.message);
      }
    }
  };

  const handleInputChange = (e) => {
    inputValidator(e, formik.handleChange);
    if (duplicate_detail) {
      inputValidator(
        {
          target: {
            name: "ubo_" + e.target.name.toLowerCase(),
            value: e.target.value,
          },
        },
        formik.handleChange,
      );
    }
  };

  // triggering  otp screen pop on submission
  useEffect(() => {
    if (is_otp_verified === true) {
      handleSubmit();
      setIsOtpVerfied(false);
    }
  }, [is_otp_verified]);

  useEffect(() => {
    if (duplicate_detail) {
      formik.setValues({
        ...formik.values,
        ubo_first_name: formik.values.First_name,
        ubo_last_name: formik.values.Last_name,
        ubo_date_of_birth: formik.values.Date_of_birth,
        ubo_middle_name: formik.values.Middle_name,
        ubo_email: formik.values.email,
        ubo_mobile: formik.values.mobile,
        ubo_occupation: formik.values.occupation,
        ubo_country_of_birth: formik.values.Country_of_birth,
      });
      setUboAreaCode(selected_area_code);
      setSelectedUboCountryOfBirth(selectedCountryOfBirth);
    }
  }, [duplicate_detail]);

  const setCheck = (value) => {
    if (value) {
      setDuplicateDetail(true);
    } else {
      setDuplicateDetail(false);
      setUboMiddleNameOptional(false);
      formik.setValues({
        ...formik.values,
        ubo_first_name: "",
        ubo_last_name: "",
        ubo_date_of_birth: "",
        ubo_middle_name: "",
        ubo_email: "",
        ubo_mobile: "",
        ubo_occupation: "",
        ubo_country_of_birth: "",
      });
      setUboAreaCode("61");
      setSelectedUboCountryOfBirth(null);
    }
  };

  // Custom styles for react-select
  const selectStyles = {
    control: (provided, state) => ({
      ...provided,
      backgroundColor: "rgba(252, 253, 255, 0.81)",
      borderColor: state.isFocused ? "#6414E9" : "#ced4da",
      boxShadow: state.isFocused
        ? "0 0 0 0.2rem rgba(100, 20, 233, 0.25)"
        : "none",
      "&:hover": {
        borderColor: "#6414E9",
      },
      minHeight: "38px",
      ...(state.selectProps.className?.includes("is-invalid") && {
        borderColor: "#dc3545",
        "&:hover": {
          borderColor: "#dc3545",
        },
      }),
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected
        ? "#6414E9"
        : state.isFocused
          ? "#f0e9ff"
          : "white",
      color: state.isSelected ? "white" : "#212529",
      "&:hover": {
        backgroundColor: "#f0e9ff",
        color: "#212529",
      },
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 9999,
    }),
    input: (provided) => ({
      ...provided,
      color: "#212529",
    }),
    placeholder: (provided) => ({
      ...provided,
      color: "#6c757d",
    }),
    singleValue: (provided) => ({
      ...provided,
      color: "#212529",
    }),
  };

  return (
    <>
      <section className="edit_recipient_section">
        <div className="form-head mb-4">
          <span className="text-black font-w600 mb-0 h2">
            <b>Profile Information</b>
          </span>
          {verification_status === "approved" ? (
            <span className="verified_text px-2 py-1 fs-5 mx-3">
              KYC Approved
            </span>
          ) : verification_status === "declined" ? (
            <span className="unverified_text px-2 py-1 fs-5 mx-3">
              KYC Declined
            </span>
          ) : verification_status === "pending" ||
            verification_status === "abandoned" ? (
            <span className="pending_verified_text px-2 py-1 fs-5 mx-3">
              KYC Pending
            </span>
          ) : verification_status === "resubmission_requested" ? (
            <span className="pending_verified_text px-2 py-1 fs-5 mx-3">
              KYC Resubmission Required
            </span>
          ) : (
            <span className="pending_verified_text px-2 py-1 fs-5 mx-3">
              KYC Submitted
            </span>
          )}
        </div>
        <form
          onSubmit={formik.handleSubmit}
          noValidate
          className="single-recipient"
        >
          <div className="card">
            <div className="card-body">
              <div className="row each-row">
                <h5>Account Type</h5>
                <div className="col-12">
                  <div className="input_field">
                    <input
                      type="text"
                      name="account_type"
                      value={account_type}
                      disabled
                      readOnly
                      className={clsx(
                        "form-control bg-transparent text-capitalize",
                      )}
                    />
                  </div>
                </div>
              </div>

              {account_type === "business" && (
                <>
                  <div className="row each-row">
                    <h5>Business Details</h5>
                    <div className="col-md-4">
                      <div className="input_field">
                        <p className="get-text">
                          Name of Business
                          <span style={{ color: "red" }}>*</span>
                        </p>
                        <input
                          type="text"
                          name="business_name"
                          value={formik.values.business_name}
                          onChange={handleInputChange}
                          maxLength={limits.business_name.max}
                          readOnly={isFieldsLocked}
                          disabled={isFieldsLocked}
                          className={clsx(
                            "form-control bg-transparent",
                            {
                              "is-invalid":
                                !isFieldsLocked &&
                                formik.touched.business_name &&
                                formik.errors.business_name,
                            },
                            {
                              "is-valid":
                                !isFieldsLocked &&
                                formik.touched.business_name &&
                                !formik.errors.business_name,
                            },
                          )}
                          onBlurCapture={formik.handleBlur}
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="input_field">
                        <p className="get-text">
                          Nature of Business
                          <span style={{ color: "red" }}>*</span>
                        </p>
                        <input
                          type="text"
                          name="business_nature"
                          value={formik.values.business_nature}
                          onChange={handleInputChange}
                          maxLength={limits.business_nature.max}
                          readOnly={isFieldsLocked}
                          disabled={isFieldsLocked}
                          className={clsx(
                            "form-control bg-transparent",
                            {
                              "is-invalid":
                                !isFieldsLocked &&
                                formik.touched.business_nature &&
                                formik.errors.business_nature,
                            },
                            {
                              "is-valid":
                                !isFieldsLocked &&
                                formik.touched.business_nature &&
                                !formik.errors.business_nature,
                            },
                          )}
                          onBlurCapture={formik.handleBlur}
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="input_field">
                        <p className="get-text">
                          Registration Number
                          <span style={{ color: "red" }}>*</span>
                        </p>
                        <input
                          type="text"
                          name="registration_number"
                          value={formik.values.registration_number}
                          onChange={handleInputChange}
                          maxLength={limits.registration_number.max}
                          readOnly={isFieldsLocked}
                          disabled={isFieldsLocked}
                          className={clsx(
                            "form-control bg-transparent",
                            {
                              "is-invalid":
                                !isFieldsLocked &&
                                formik.touched.registration_number &&
                                formik.errors.registration_number,
                            },
                            {
                              "is-valid":
                                !isFieldsLocked &&
                                formik.touched.registration_number &&
                                !formik.errors.registration_number,
                            },
                          )}
                          onBlurCapture={formik.handleBlur}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row each-row">
                    <div className="col-md-4">
                      <div className="input_field">
                        <p className="get-text">
                          Registration Date
                          <span style={{ color: "red" }}>*</span>
                        </p>
                        <input
                          type="date"
                          id="registration_date"
                          name="registration_date"
                          value={formik.values.registration_date}
                          onChange={formik.handleChange}
                          readOnly={isFieldsLocked}
                          disabled={isFieldsLocked}
                          className={clsx(
                            "form-control bg-transparent",
                            {
                              "is-invalid":
                                !isFieldsLocked &&
                                formik.touched.registration_date &&
                                formik.errors.registration_date,
                            },
                            {
                              "is-valid":
                                !isFieldsLocked &&
                                formik.touched.registration_date &&
                                !formik.errors.registration_date,
                            },
                          )}
                          onBlurCapture={formik.handleBlur}
                        />
                        {!isFieldsLocked &&
                          formik.touched.registration_date &&
                          formik.errors.registration_date &&
                          formik.values.registration_date !== "" && (
                            <div className="fv-plugins-message-container mt-1">
                              <div className="fv-help-block">
                                <span role="alert" className="text-danger">
                                  {formik.errors.registration_date}
                                </span>
                              </div>
                            </div>
                          )}
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="input_field">
                        <p className="get-text">
                          Registration Country
                          <span style={{ color: "red" }}>*</span>
                        </p>
                        <Select
                          options={countrySelectOptions}
                          value={selectedRegistrationCountry}
                          onChange={handleRegistrationCountryChange}
                          onBlur={() =>
                            formik.setFieldTouched(
                              "registration_country",
                              true,
                              true,
                            )
                          }
                          placeholder="Search country..."
                          isClearable
                          isSearchable
                          styles={selectStyles}
                          isDisabled={isFieldsLocked}
                          className={clsx({
                            "is-invalid":
                              !isFieldsLocked &&
                              formik.touched.registration_country &&
                              formik.errors.registration_country,
                          })}
                          noOptionsMessage={() => "No countries found"}
                        />
                        {!isFieldsLocked &&
                          formik.touched.registration_country &&
                          formik.errors.registration_country && (
                            <div className="fv-plugins-message-container mt-1">
                              <div className="fv-help-block">
                                <span role="alert" className="text-danger">
                                  {formik.errors.registration_country}
                                </span>
                              </div>
                            </div>
                          )}
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="input_field">
                        <p className="get-text">
                          Business Address
                          <span style={{ color: "red" }}>*</span>
                        </p>
                        <Autocomplete
                          apiKey={process.env.REACT_APP_GOOGLE_API_KEY}
                          placeholder="Street Address, Company or P.O. box.. "
                          id="business_address"
                          name="business_address"
                          options={{
                            types: [],
                            componentRestrictions: {
                              country: getBusinessCountryCode(
                                formik.values?.registration_country,
                              ),
                            },
                          }}
                          onPlaceSelected={(e) =>
                            formik.handleChange({
                              target: {
                                name: "business_address",
                                value: e.formatted_address,
                              },
                            })
                          }
                          onChange={formik.handleChange}
                          value={formik.values.business_address}
                          onBlurCapture={formik.handleBlur}
                          readOnly={isFieldsLocked}
                          disabled={isFieldsLocked}
                          className={clsx(
                            "form-control bg-transparent",
                            {
                              "is-invalid":
                                !isFieldsLocked &&
                                formik.touched.business_address &&
                                formik.errors.business_address,
                            },
                            {
                              "is-valid":
                                !isFieldsLocked &&
                                formik.touched.business_address &&
                                !formik.errors.business_address,
                            },
                          )}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row each-row">
                    <p className="mb-3">
                      <h5>Account Usage</h5>
                      <span className="small">
                        &nbsp;(Utilization above tier 1 requires additional
                        verification documents.)
                      </span>
                    </p>
                    <div className="col-md-6">
                      <div className="input_field">
                        <p className="get-text">
                          Projected frequency of payments per annum
                        </p>
                        <input
                          type="text"
                          name="payment_per_anmum"
                          value={formik.values.payment_per_annum}
                          {...formik.getFieldProps("payment_per_annum")}
                          disabled
                          className={clsx("form-control bg-transparent")}
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="input_field">
                        <p className="get-text">
                          Projected value of payments per annum
                        </p>
                        <input
                          type="text"
                          name="value_per_annum"
                          value={formik.values.value_per_annum}
                          {...formik.getFieldProps("value_per_annum")}
                          disabled
                          className={clsx("form-control bg-transparent")}
                        />
                      </div>
                    </div>
                  </div>
                </>
              )}

              <div className="row each-row">
                {account_type === "business" ? (
                  <h5>Authorised Business Representative</h5>
                ) : (
                  <h5>Personal Details</h5>
                )}
                <div className="col-md-4  mt-3">
                  <div className="input_field">
                    <p className="get-text">
                      First Name<span style={{ color: "red" }}>*</span>
                    </p>
                    <input
                      type="text"
                      name="First_name"
                      value={formik.values.First_name}
                      onChange={handleInputChange}
                      readOnly={isFieldsLocked}
                      disabled={isFieldsLocked}
                      maxLength={limits.name}
                      className={clsx(
                        "form-control bg-transparent",
                        {
                          "is-invalid":
                            !isFieldsLocked &&
                            formik.touched.First_name &&
                            formik.errors.First_name,
                        },
                        {
                          "is-valid":
                            !isFieldsLocked &&
                            formik.touched.First_name &&
                            !formik.errors.First_name,
                        },
                      )}
                      onBlurCapture={formik.handleBlur}
                    />
                  </div>
                </div>
                <div className="col-md-4  mt-3">
                  <div className="input_field">
                    <p className="get-text">
                      Middle Name
                      {!middle_name_optional && (
                        <span style={{ color: "red" }}>*</span>
                      )}
                    </p>
                    <input
                      type="text"
                      name="Middle_name"
                      maxLength={limits.name}
                      onChange={handleInputChange}
                      value={formik.values.Middle_name}
                      readOnly={isFieldsLocked || middle_name_optional}
                      disabled={isFieldsLocked || middle_name_optional}
                      className={clsx(
                        "form-control bg-transparent",
                        {
                          "is-invalid":
                            !middle_name_optional &&
                            formik.touched.Middle_name &&
                            formik.errors.Middle_name,
                        },
                        {
                          "is-valid":
                            !middle_name_optional &&
                            formik.touched.Middle_name &&
                            !formik.errors.Middle_name,
                        },
                      )}
                      onBlurCapture={formik.handleBlur}
                    />
                    {!middle_name_optional &&
                      formik.touched.Middle_name &&
                      formik.errors.Middle_name && (
                        <div className="fv-plugins-message-container mt-1">
                          <div className="fv-help-block">
                            <span role="alert" className="text-danger">
                              {formik.errors.Middle_name}
                            </span>
                          </div>
                        </div>
                      )}
                    {/* Checkbox to make middle name optional */}
                    <div className="d-flex align-items-center gap-2 mt-2">
                      <input
                        type="checkbox"
                        id="middle_name_optional_check"
                        checked={middle_name_optional}
                        onChange={({ target }) => {
                          setMiddleNameOptional(target.checked);
                          if (target.checked) {
                            formik.setFieldValue("Middle_name", "", false);
                            formik.setFieldTouched("Middle_name", false, false);
                            if (duplicate_detail) {
                              formik.setFieldValue(
                                "ubo_middle_name",
                                "",
                                false,
                              );
                            }
                          }
                        }}
                        disabled={isFieldsLocked}
                      />
                      <label
                        htmlFor="middle_name_optional_check"
                        className="mb-0"
                        style={{ fontSize: "13px", cursor: "pointer" }}
                      >
                        Middle name is optional
                      </label>
                    </div>
                  </div>
                </div>
                <div className="col-md-4 mt-3">
                  <div className="input_field">
                    <p className="get-text">
                      Last Name<span style={{ color: "red" }}>*</span>
                    </p>
                    <input
                      type="text"
                      name="Last_name"
                      value={formik.values.Last_name}
                      maxLength={limits.name}
                      onChange={handleInputChange}
                      readOnly={isFieldsLocked}
                      disabled={isFieldsLocked}
                      className={clsx(
                        "form-control bg-transparent",
                        {
                          "is-invalid":
                            !isFieldsLocked &&
                            formik.touched.Last_name &&
                            formik.errors.Last_name,
                        },
                        {
                          "is-valid":
                            !isFieldsLocked &&
                            formik.touched.Last_name &&
                            !formik.errors.Last_name,
                        },
                      )}
                      onBlurCapture={formik.handleBlur}
                    />
                  </div>
                </div>
                <div className="col-md-4 mt-3">
                  <div className="input_field">
                    <p className="get-text">Customer Id</p>
                    <input
                      type="text"
                      value={formik.values.customer_id}
                      style={{ backgroundColor: "rgba(252, 253, 255, 0.81)" }}
                      className="form-control"
                      readOnly
                    />
                  </div>
                </div>
                <div className="col-md-4 mt-3">
                  <div className="input_field">
                    <p className="get-text">
                      Email<span style={{ color: "red" }}>*</span>
                    </p>
                    <input
                      type="email"
                      name="email"
                      value={formik.values.email}
                      style={{ backgroundColor: "rgba(252, 253, 255, 0.81)" }}
                      maxLength={limits.email.max}
                      onChange={(e) => {
                        handleInputChange(e);
                      }}
                      onBlur={formik.handleBlur}
                      className={clsx(
                        "form-control bg-transparent",
                        {
                          "is-invalid":
                            formik.touched.email && formik.errors.email,
                        },
                        {
                          "is-valid":
                            formik.touched.email && !formik.errors.email,
                        },
                      )}
                      readOnly={isFieldsLocked}
                      disabled={isFieldsLocked}
                    />
                  </div>
                </div>
                <div className="col-md-4  mt-3">
                  <div className="input_field">
                    <p className="get-text">
                      Mobile<span style={{ color: "red" }}>*</span>
                    </p>
                    <div className="row kustom_mobile">
                      <div className="col-md-5 px-0 select-padding">
                        <select
                          className="form-control form-select bg-transparent"
                          value={selected_area_code}
                          onChange={(e) => {
                            setSelectedAreaCode(e.target.value);
                            if (duplicate_detail) {
                              setUboAreaCode(e.target.value);
                            }
                          }}
                          readOnly={isFieldsLocked}
                          disabled={isFieldsLocked}
                        >
                          {phoneCountries?.map((country, index) => (
                            <option key={index} value={country.phone_code}>
                              +{country.phone_code} (
                              {country.country_code?.toUpperCase()})
                            </option>
                          ))}
                        </select>
                      </div>

                      <div className={`col-md-7 px-0`}>
                        <input
                          type="text"
                          name="mobile"
                          value={formik.values.mobile || ""}
                          id="mobile"
                          onChange={(e) => {
                            let result = e.target.value.replace(/[^0-9]/, "");
                            let removedZeros = result.replace(/^0+/, "");
                            if (removedZeros.length > limits.user_mobile.max)
                              return;
                            formik.setFieldValue("mobile", result);
                          }}
                          className={clsx(
                            "form-control bg-transparent",
                            {
                              "is-invalid":
                                formik.touched.mobile && formik.errors.mobile,
                            },
                            {
                              "is-valid":
                                formik.touched.mobile && !formik.errors.mobile,
                            },
                          )}
                          readOnly={isFieldsLocked}
                          disabled={isFieldsLocked}
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-md-4  mt-3">
                  <div className="input_field">
                    <p className="get-text">
                      Date of Birth<span style={{ color: "red" }}>*</span>
                    </p>
                    <input
                      type="date"
                      name="Date_of_birth"
                      value={formik.values.Date_of_birth}
                      id="dob"
                      onChange={handleInputChange}
                      readOnly={isFieldsLocked}
                      disabled={isFieldsLocked}
                      min={min_date}
                      max={max_date}
                      className={clsx(
                        "form-control bg-transparent",
                        {
                          "is-invalid":
                            !isFieldsLocked &&
                            formik.touched.Date_of_birth &&
                            formik.errors.Date_of_birth,
                        },
                        {
                          "is-valid":
                            !isFieldsLocked &&
                            formik.touched.Date_of_birth &&
                            !formik.errors.Date_of_birth,
                        },
                      )}
                      onBlurCapture={formik.handleBlur}
                    />
                    {formik.touched.Date_of_birth &&
                      formik.errors.Date_of_birth &&
                      formik.values.Date_of_birth !== "" && (
                        <div className="fv-plugins-message-container mt-1">
                          <div className="fv-help-block">
                            <span role="alert" className="text-danger">
                              {formik.errors.Date_of_birth}
                            </span>
                          </div>
                        </div>
                      )}
                  </div>
                </div>
                <div className="col-md-4  mt-3">
                  <div className="input_field">
                    <p className="get-text">
                      Country Of Birth<span style={{ color: "red" }}>*</span>
                    </p>
                    <Select
                      options={countrySelectOptions}
                      value={selectedCountryOfBirth}
                      onChange={handleCountryOfBirthChange}
                      onBlur={() =>
                        formik.setFieldTouched("Country_of_birth", true, true)
                      }
                      placeholder="Search country..."
                      isClearable
                      isSearchable
                      styles={selectStyles}
                      isDisabled={isFieldsLocked}
                      className={clsx({
                        "is-invalid":
                          formik.touched.Country_of_birth &&
                          formik.errors.Country_of_birth,
                      })}
                      noOptionsMessage={() => "No countries found"}
                    />
                    {formik.touched.Country_of_birth &&
                      formik.errors.Country_of_birth && (
                        <div className="fv-plugins-message-container mt-1">
                          <div className="fv-help-block">
                            <span role="alert" className="text-danger">
                              {formik.errors.Country_of_birth}
                            </span>
                          </div>
                        </div>
                      )}
                  </div>
                </div>
                <div className="col-md-4  mt-3">
                  <div className="input_field">
                    <p className="get-text">
                      Occupation<span style={{ color: "red" }}>*</span>
                    </p>
                    <input
                      type="text"
                      name="occupation"
                      value={formik.values.occupation}
                      id="occupation"
                      maxLength={limits.occupation}
                      onChange={handleInputChange}
                      className={clsx(
                        "form-control bg-transparent",
                        {
                          "is-invalid":
                            formik.touched.occupation &&
                            formik.errors.occupation,
                        },
                        {
                          "is-valid":
                            formik.touched.occupation &&
                            !formik.errors.occupation,
                        },
                      )}
                      onBlurCapture={formik.handleBlur}
                    />
                  </div>
                </div>
              </div>
              {account_type === "business" && (
                <>
                  <div className="row each-row">
                    <div className="d-flex gap-2 mb-4">
                      <input
                        type="checkbox"
                        className="form-check h-32 w-32"
                        title="Select if Ultimate Business Owner is same as Authorised Business Representative"
                        checked={duplicate_detail}
                        onChange={({ target }) => {
                          setCheck(target.checked);
                        }}
                        disabled={isFieldsLocked}
                      />
                      <span>
                        Select if Ultimate Business Owner is same as Authorised
                        Business Representative
                      </span>
                    </div>
                  </div>
                  <div className="row each-row">
                    <h5 className="mb-0 pb-0">
                      Ultimate Business Owner (UBO){" "}
                    </h5>
                    <small className="mb-3">(with over 10% shareholding)</small>
                    {/* ubo first name */}
                    <div className="col-md-4 mb-4">
                      <div className="input_field">
                        <p className="get-text">
                          First Name<span style={{ color: "red" }}>*</span>
                        </p>
                        <input
                          type="text"
                          name="ubo_first_name"
                          value={formik.values.ubo_first_name}
                          onChange={handleInputChange}
                          maxLength={limits.name}
                          className={clsx(
                            "form-control bg-transparent",
                            {
                              "is-invalid":
                                formik.touched.ubo_first_name &&
                                formik.errors.ubo_first_name,
                            },
                            {
                              "is-valid":
                                formik.touched.ubo_first_name &&
                                !formik.errors.ubo_first_name,
                            },
                          )}
                          onBlurCapture={formik.handleBlur}
                          disabled={isFieldsLocked || duplicate_detail}
                        />
                      </div>
                    </div>
                    {/* ubo middle name */}
                    <div className="col-md-4 mb-4">
                      <div className="input_field">
                        <p className="get-text">
                          Middle Name
                          {!ubo_middle_name_optional && (
                            <span style={{ color: "red" }}>*</span>
                          )}
                        </p>
                        <input
                          type="text"
                          name="ubo_middle_name"
                          className={clsx(
                            "form-control bg-transparent",
                            {
                              "is-invalid":
                                !ubo_middle_name_optional &&
                                formik.touched.ubo_middle_name &&
                                formik.errors.ubo_middle_name,
                            },
                            {
                              "is-valid":
                                !ubo_middle_name_optional &&
                                formik.touched.ubo_middle_name &&
                                !formik.errors.ubo_middle_name,
                            },
                          )}
                          maxLength={limits.name}
                          onChange={handleInputChange}
                          value={formik.values.ubo_middle_name}
                          disabled={
                            isFieldsLocked ||
                            duplicate_detail ||
                            ubo_middle_name_optional
                          }
                        />
                        {!ubo_middle_name_optional &&
                          formik.touched.ubo_middle_name &&
                          formik.errors.ubo_middle_name && (
                            <div className="fv-plugins-message-container mt-1">
                              <div className="fv-help-block">
                                <span role="alert" className="text-danger">
                                  {formik.errors.ubo_middle_name}
                                </span>
                              </div>
                            </div>
                          )}
                        {/* Checkbox to make UBO middle name optional */}
                        <div className="d-flex align-items-center gap-2 mt-2">
                          <input
                            type="checkbox"
                            id="ubo_middle_name_optional_check"
                            checked={ubo_middle_name_optional}
                            onChange={({ target }) => {
                              setUboMiddleNameOptional(target.checked);
                              if (target.checked) {
                                formik.setFieldValue(
                                  "ubo_middle_name",
                                  "",
                                  false,
                                );
                                formik.setFieldTouched(
                                  "ubo_middle_name",
                                  false,
                                  false,
                                );
                              }
                            }}
                            disabled={isFieldsLocked || duplicate_detail}
                          />
                          <label
                            htmlFor="ubo_middle_name_optional_check"
                            className="mb-0"
                            style={{ fontSize: "13px", cursor: "pointer" }}
                          >
                            Middle name is optional
                          </label>
                        </div>
                      </div>
                    </div>{" "}
                    {/*  ubo last name */}
                    <div className="col-md-4 mb-4">
                      <div className="input_field">
                        <p className="get-text">
                          Last Name<span style={{ color: "red" }}>*</span>
                        </p>
                        <input
                          type="text"
                          name="ubo_last_name"
                          value={formik.values.ubo_last_name}
                          maxLength={limits.name}
                          onChange={handleInputChange}
                          className={clsx(
                            "form-control bg-transparent",
                            {
                              "is-invalid":
                                formik.touched.ubo_last_name &&
                                formik.errors.ubo_last_name,
                            },
                            {
                              "is-valid":
                                formik.touched.ubo_last_name &&
                                !formik.errors.ubo_last_name,
                            },
                          )}
                          onBlurCapture={formik.handleBlur}
                          disabled={isFieldsLocked || duplicate_detail}
                        />
                      </div>
                    </div>
                    {/* ubo email */}
                    <div className="col-md-4 mb-4">
                      <div className="input_field">
                        <p className="get-text">
                          Email<span style={{ color: "red" }}>*</span>
                        </p>
                        <input
                          type="email"
                          name="ubo_email"
                          value={formik.values.ubo_email}
                          style={{
                            backgroundColor: "rgba(252, 253, 255, 0.81)",
                          }}
                          onChange={handleInputChange}
                          maxLength={limits.email.max}
                          className={clsx(
                            "form-control bg-transparent",
                            {
                              "is-invalid":
                                formik.touched.ubo_email &&
                                formik.errors.ubo_email,
                            },
                            {
                              "is-valid":
                                formik.touched.ubo_email &&
                                !formik.errors.ubo_email,
                            },
                          )}
                          disabled={isFieldsLocked || duplicate_detail}
                        />
                      </div>
                    </div>
                    {/* ubo mno  */}
                    <div className="col-md-4 mb-4">
                      <div className="input_field">
                        <p className="get-text">
                          Mobile<span style={{ color: "red" }}>*</span>
                        </p>
                        <div className="row kustom_mobile">
                          {/* Country Code Select */}
                          <div className="col-md-5 px-0 select-padding">
                            <select
                              className="form-control form-select bg-transparent"
                              value={ubo_area_code}
                              onChange={(e) => setUboAreaCode(e.target.value)}
                              disabled={isFieldsLocked || duplicate_detail}
                            >
                              {phoneCountries?.map((country, index) => (
                                <option key={index} value={country.phone_code}>
                                  +{country.phone_code} (
                                  {country.country_code?.toUpperCase()})
                                </option>
                              ))}
                            </select>
                          </div>

                          {/* Mobile Number Input */}
                          <div className={`col-md-7 px-0`}>
                            <input
                              type="text"
                              name="ubo_mobile"
                              value={
                                duplicate_detail
                                  ? formik.values.mobile || ""
                                  : formik.values.ubo_mobile
                              }
                              id="ubo_mobile"
                              onChange={(e) => {
                                let result = e.target.value.replace(
                                  /[^0-9]/,
                                  "",
                                );
                                let removedZeros = result.replace(/^0+/, "");
                                if (
                                  removedZeros.length > limits.user_mobile.max
                                )
                                  return;
                                formik.setFieldValue("ubo_mobile", result);
                              }}
                              onBlur={formik.handleBlur}
                              className={clsx(
                                "form-control bg-transparent",
                                {
                                  "is-invalid":
                                    formik.touched.ubo_mobile &&
                                    formik.errors.ubo_mobile,
                                },
                                {
                                  "is-valid":
                                    formik.touched.ubo_mobile &&
                                    !formik.errors.ubo_mobile,
                                },
                              )}
                              disabled={isFieldsLocked || duplicate_detail}
                            />
                          </div>
                        </div>

                        {/* Error Message */}
                        {formik.touched.ubo_mobile &&
                          formik.errors.ubo_mobile && (
                            <div className="invalid-feedback d-block">
                              {formik.errors.ubo_mobile}
                            </div>
                          )}
                      </div>
                    </div>
                    {/* ubo  dob */}
                    <div className="col-md-4 mb-4">
                      <div className="input_field">
                        <p className="get-text">
                          Date of Birth<span style={{ color: "red" }}>*</span>
                        </p>
                        <input
                          type="date"
                          name="ubo_date_of_birth"
                          value={formik.values.ubo_date_of_birth}
                          id="ubo_dob"
                          onChange={formik.handleChange}
                          className={clsx(
                            "form-control bg-transparent",
                            {
                              "is-invalid":
                                formik.touched.ubo_date_of_birth &&
                                formik.errors.ubo_date_of_birth,
                            },
                            {
                              "is-valid":
                                formik.touched.ubo_date_of_birth &&
                                !formik.errors.ubo_date_of_birth,
                            },
                          )}
                          disabled={isFieldsLocked || duplicate_detail}
                          onBlurCapture={formik.handleBlur}
                        />
                        {formik.touched.ubo_date_of_birth &&
                          formik.errors.ubo_date_of_birth &&
                          formik.values.ubo_date_of_birth !== "" && (
                            <div className="fv-plugins-message-container mt-1">
                              <div className="fv-help-block">
                                <span role="alert" className="text-danger">
                                  {formik.errors.ubo_date_of_birth}
                                </span>
                              </div>
                            </div>
                          )}
                      </div>
                    </div>
                    {/* ubo country of birth */}
                    <div className="col-md-4 country-h mb-4">
                      <div className="input_field">
                        <p className="get-text">
                          Country of Birth
                          <span style={{ color: "red" }}>*</span>
                        </p>
                        <Select
                          options={countrySelectOptions}
                          value={selectedUboCountryOfBirth}
                          onChange={handleUboCountryOfBirthChange}
                          onBlur={() =>
                            formik.setFieldTouched(
                              "ubo_country_of_birth",
                              true,
                              true,
                            )
                          }
                          placeholder="Select or search country..."
                          isClearable
                          isSearchable
                          styles={selectStyles}
                          isDisabled={isFieldsLocked || duplicate_detail}
                          className={clsx({
                            "is-invalid":
                              formik.touched.ubo_country_of_birth &&
                              formik.errors.ubo_country_of_birth,
                          })}
                          noOptionsMessage={() => "No countries found"}
                        />
                        {formik.touched.ubo_country_of_birth &&
                          formik.errors.ubo_country_of_birth && (
                            <div className="fv-plugins-message-container mt-1">
                              <div className="fv-help-block">
                                <span role="alert" className="text-danger">
                                  {formik.errors.ubo_country_of_birth}
                                </span>
                              </div>
                            </div>
                          )}
                      </div>
                    </div>
                    {/*  ubo occupation */}
                    <div className="col-md-4 mb-4">
                      <div className="input_field">
                        <p className="get-text">
                          Occupation<span style={{ color: "red" }}>*</span>
                        </p>
                        <input
                          type="text"
                          name="ubo_occupation"
                          value={formik.values.ubo_occupation}
                          id="ubo_occupation"
                          maxLength={limits.occupation}
                          onChange={handleInputChange}
                          className={clsx(
                            "form-control bg-transparent",
                            {
                              "is-invalid":
                                formik.touched.ubo_occupation &&
                                formik.errors.ubo_occupation,
                            },
                            {
                              "is-valid":
                                formik.touched.ubo_occupation &&
                                !formik.errors.ubo_occupation,
                            },
                          )}
                          onBlurCapture={formik.handleBlur}
                        />
                      </div>
                    </div>
                  </div>
                </>
              )}
              {account_type !== "business" && (
                <div className="row each-row">
                  <p className="mb-3">
                    <span className="h5">Account Usage</span>
                    <span className="small">
                      &nbsp;(Utilization above tier 1 requires additional
                      verification documents.)
                    </span>
                  </p>
                  <div className="col-md-6">
                    <div className="input_field">
                      <p className="get-text">
                        Projected frequency of payments per annum
                      </p>
                      <input
                        type="text"
                        name="payment_per_anmum"
                        value={formik.values.payment_per_annum}
                        {...formik.getFieldProps("payment_per_annum")}
                        disabled
                        className={clsx("form-control bg-transparent")}
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="input_field">
                      <p className="get-text">
                        Projected value of payments per annum
                      </p>
                      <input
                        type="text"
                        name="value_per_annum"
                        value={formik.values.value_per_annum}
                        {...formik.getFieldProps("value_per_annum")}
                        disabled
                        className={clsx("form-control bg-transparent")}
                      />
                    </div>
                  </div>
                </div>
              )}
              <div className="row each-row">
                {account_type === "business" ? (
                  <h5>Authorised Business Representative Address</h5>
                ) : (
                  <h5>Your Address</h5>
                )}
                <div className="col-md-6 mb-3">
                  <Form.Group className="form_label" controlId="country">
                    <p className="get-text">
                      Country<span style={{ color: "red" }}>*</span>
                    </p>
                    <Select
                      options={apiCountrySelectOptions}
                      value={selectedCountry}
                      onChange={countryHandler}
                      onBlur={() =>
                        formik.setFieldTouched("country", true, true)
                      }
                      placeholder="Select or search country..."
                      isClearable
                      isSearchable
                      styles={selectStyles}
                      className={clsx({
                        "is-invalid":
                          formik.touched.country && formik.errors.country,
                      })}
                      noOptionsMessage={() => "No countries found"}
                    />
                    {formik.touched.country && formik.errors.country && (
                      <div className="fv-plugins-message-container mt-1">
                        <div className="fv-help-block">
                          <span role="alert" className="text-danger">
                            {formik.errors.country}
                          </span>
                        </div>
                      </div>
                    )}
                  </Form.Group>
                </div>
              </div>
              <div className="row each-row">
                <div className="col-md-12 mb-3">
                  <Form.Group className="form_label" controlId="address">
                    <p className="get-text">Address</p>
                    <Autocomplete
                      apiKey={process.env.REACT_APP_GOOGLE_API_KEY}
                      onPlaceSelected={(value) => {
                        const currentCountry =
                          formik.values.country &&
                          formik.values.country !== "none"
                            ? formik.values.country
                            : null;
                        getSelectedStreet(
                          value,
                          formik.setFieldValue,
                          currentCountry,
                        );
                      }}
                      placeholder="Street Address, Company or P.O. box.. "
                      id="address"
                      name="address"
                      className="form-control"
                      options={{
                        types: [],
                        componentRestrictions: {
                          country: getCountryCode(formik.values.country),
                        },
                      }}
                      onChange={formik.handleChange}
                      value={formik.values.address}
                    />
                  </Form.Group>
                </div>
              </div>
              <div className="row each-row">
                <div className="col-md-4 mb-3">
                  <Form.Group className="form_label" controlId="flat">
                    <p className="get-text">Unit/Apt No.</p>
                    <input
                      type="text"
                      name="flat"
                      value={formik.values.flat}
                      onChange={handleInputChange}
                      maxLength={limits.flat}
                      className={clsx("form-control bg-transparent")}
                      onBlurCapture={formik.handleBlur}
                    />
                  </Form.Group>
                </div>
                <div className="col-md-4 mb-3">
                  <Form.Group className="form_label" controlId="building">
                    <p className="get-text">
                      Building No.<span style={{ color: "red" }}>*</span>
                    </p>
                    <input
                      type="text"
                      name="building"
                      value={formik.values.building}
                      onChange={handleInputChange}
                      maxLength={limits.building}
                      className={clsx(
                        "form-control bg-transparent",
                        {
                          "is-invalid":
                            formik.touched.building && formik.errors.building,
                        },
                        {
                          "is-valid":
                            formik.touched.building && !formik.errors.building,
                        },
                      )}
                      onBlurCapture={formik.handleBlur}
                    />
                  </Form.Group>
                </div>
                <div className="col-md-4 mb-3">
                  <Form.Group className="form_label" controlId="street_name">
                    <p className="get-text">
                      Street Name<span style={{ color: "red" }}>*</span>
                    </p>
                    <input
                      type="text"
                      name="street"
                      value={formik.values.street}
                      onChange={handleInputChange}
                      maxLength={limits.street}
                      className={clsx(
                        "form-control bg-transparent",
                        {
                          "is-invalid":
                            formik.touched.street && formik.errors.street,
                        },
                        {
                          "is-valid":
                            formik.touched.street && !formik.errors.street,
                        },
                      )}
                      onBlurCapture={formik.handleBlur}
                    />
                  </Form.Group>
                </div>
              </div>
              <div className="row each-row">
                <div className="col-md-4 mb-3">
                  <Form.Group className="form_label" controlId="city">
                    <p className="get-text">
                      City/Suburb<span style={{ color: "red" }}>*</span>
                    </p>
                    <input
                      type="text"
                      name="city"
                      value={formik.values.city}
                      maxLength={limits.city}
                      onChange={handleInputChange}
                      className={clsx(
                        "form-control bg-transparent",
                        {
                          "is-invalid":
                            formik.touched.city && formik.errors.city,
                        },
                        {
                          "is-valid":
                            formik.touched.city && !formik.errors.city,
                        },
                      )}
                      placeholder="city or suburb .."
                      onBlurCapture={formik.handleBlur}
                    />
                  </Form.Group>
                </div>
                <div className="col-md-4 mb-3">
                  <Form.Group className="form_label" controlId="postal">
                    <p className="get-text">
                      Zip/Postal Code<span style={{ color: "red" }}>*</span>
                    </p>
                    <input
                      type="text"
                      name="postcode"
                      value={formik.values.postcode}
                      maxLength={limits.user_zip}
                      onChange={handleInputChange}
                      className={clsx(
                        "form-control bg-transparent",
                        {
                          "is-invalid":
                            formik.touched.postcode && formik.errors.postcode,
                        },
                        {
                          "is-valid":
                            formik.touched.postcode && !formik.errors.postcode,
                        },
                      )}
                      onBlur={formik.handleBlur}
                    />
                    {formik.touched.postcode && formik.errors.postcode && (
                      <div className="invalid-feedback">
                        {formik.errors.postcode}
                      </div>
                    )}
                  </Form.Group>
                </div>

                <div className="col-md-4 mb-3">
                  <Form.Group className="form_label statess" controlId="state">
                    <p className="get-text">
                      State<span style={{ color: "red" }}>*</span>
                    </p>
                    <input
                      type="text"
                      name="state"
                      value={formik.values.state}
                      maxLength={limits.state}
                      onChange={handleInputChange}
                      className={clsx(
                        "form-control bg-transparent",
                        {
                          "is-invalid":
                            formik.touched.state && formik.errors.state,
                        },
                        {
                          "is-valid":
                            formik.touched.state && !formik.errors.state,
                        },
                      )}
                      placeholder="state or province .."
                      onBlurCapture={formik.handleBlur}
                    />
                  </Form.Group>
                </div>
              </div>
              <div className="row">
                <div className="col-md-4"></div>
                <div className="col-md-8 full-col">
                  <button type="submit" className="form-button">
                    Update
                    {loading ? (
                      <>
                        <div className="loader-overly">
                          <div className="loader"></div>
                        </div>
                      </>
                    ) : (
                      <></>
                    )}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </form>
      </section>

      <Modal
        show={open_modal}
        onHide={() => setOpenModal(false)}
        backdrop="static"
        centered
      >
        <PopVerify
          handler={handleOtpVerification}
          close={() => {
            setOpenModal(false);
          }}
          email={is_update.email}
          phone={is_update.mobile}
          selectedOtpOption={selectedOtpOption}
          new_mobile={
            is_update.mobile !== "+" + selected_area_code + formik.values.mobile
              ? "+" + selected_area_code + formik.values.mobile
              : null
          }
        />
      </Modal>
      <Modal
        show={account_usage_updater.is_open}
        onHide={() =>
          setAccountUsageUpdater({ is_open: false, type: null, value: null })
        }
        backdrop="static"
        centered
      >
        <AccountUsageUpdator
          data={account_usage_updater}
          close={() => {
            setAccountUsageUpdater({ is_open: false, type: null, value: null });
          }}
        />
      </Modal>
      <Modal
        show={showOtpPopup}
        onHide={() => setShowOtpPopup(false)}
        centered
        dialogClassName="otp-modal"
      >
        <Modal.Body className="text-center otp-popup">
          <h4 className="fw-bold">OTP Delivery Preference</h4>
          <p className="text-muted">
            Select where you would like to receive your One-Time Password (OTP).
          </p>
          <div className="d-flex justify-content-center gap-3 my-4">
            {/* Mobile Option */}
            <div
              className={`otp-option ${
                selectedOtpOption === "mobile" ? "active" : ""
              }`}
              onClick={() => setSelectedOtpOption("mobile")}
            >
              <FaPhoneAlt size={24} />
              <Form.Check
                label="Mobile Number"
                type="radio"
                name="otpOption"
                checked={selectedOtpOption === "mobile"}
                onChange={() => setSelectedOtpOption("mobile")}
              />
            </div>
            {/* Email Option */}
            <div
              className={`otp-option ${
                selectedOtpOption === "email" ? "active" : ""
              }`}
              onClick={() => setSelectedOtpOption("email")}
            >
              <FaEnvelope size={24} />
              <Form.Check
                type="radio"
                name="otpOption"
                checked={selectedOtpOption === "email"}
                onChange={() => setSelectedOtpOption("email")}
                label="Email Id"
              />
            </div>
          </div>
          <div className="d-flex justify-content-center mt-5">
            <Button
              className="otp-btn w-50 d-flex align-items-center justify-content-center gap-4"
              onClick={handleOtpPopupContinue}
              disabled={loading}
            >
              {loading ? "SENDING..." : "CONTINUE"}
              {!loading && (
                <img
                  src="https://remitassure.com/assets/img/home/Union.svg"
                  alt="arrow"
                  style={{ width: "20px", height: "20px" }}
                />
              )}
              {loading && (
                <div className="loader-overly">
                  <div className="loader"></div>
                </div>
              )}
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

const AccountUsageUpdator = ({ data, close }) => {
  const [value, setValue] = useState("");
  const [type, setType] = useState(data.type);
  const [is_submitted, setIsSubmitted] = useState(false);
  const [loading, setLoading] = React.useState(false);

  useEffect(() => {
    setValue(data.value);
  }, [data]);

  const handleCancel = () => {
    close();
  };

  const submit = async () => {
    if (value !== data?.value) {
      setLoading(true);
      await updateAccountUsage({ type: type, value: value }).then((res) => {
        setLoading(false);
        if (res.code === "200") {
          userProfile().then((res) => {
            let user = JSON.parse(sessionStorage.getItem("remi-user-dt"));
            let local = {
              ...res?.data,
              is_digital_Id_verified: user?.is_digital_Id_verified,
            };
            sessionStorage.removeItem("remi-user-dt");
            sessionStorage.setItem("remi-user-dt", JSON.stringify(local));
          });
          setIsSubmitted(true);
        } else {
          showToast("error", "Error", res.message);
        }
      });
    } else {
      close();
    }
  };

  const handleChange = (e) => {
    setValue(e.target.value);
  };

  return (
    <>
      {loading ? (
        <>
          <div className="loader-overly">
            <div className="loader"></div>
          </div>
        </>
      ) : (
        <></>
      )}
      {!is_submitted ? (
        <>
          <Modal.Header>Update Account Usage</Modal.Header>
          <Modal.Body className="mb-5 mt-3">
            <div>
              {type === "payment_per_annum" ? (
                <>
                  <p className="get-text">
                    Projected frequency of payments per annum
                  </p>

                  <select
                    value={value}
                    name="payment_per_annum"
                    onChange={(e) => handleChange(e)}
                    className={clsx("form-control form-select bg-transparent")}
                  >
                    <option
                      value="Tier-1 Less than 5 times"
                      key="Less than 5 times"
                      disabled={data.value !== "Tier-1 Less than 5 times"}
                    >
                      Tier-1 Less than 5 times
                    </option>
                    <option
                      value="Tier-2 5-10 Times"
                      key="5-10 times"
                      disabled={data.value === "Tier-3 Greater than 10 Times"}
                    >
                      Tier-2 5-10 Times
                    </option>
                    <option
                      value="Tier-3 Greater than 10 Times"
                      key="Greater than 10 times"
                    >
                      Tier-3 Greater than 10 Times
                    </option>
                  </select>
                </>
              ) : (
                <>
                  <p className="get-text">
                    Projected value of payments per annum
                  </p>
                  <select
                    value={value}
                    name="value_per_annum"
                    onChange={(e) => handleChange(e)}
                    className={clsx("form-control form-select bg-transparent")}
                  >
                    <option
                      value="Tier-1 Less than $30,000"
                      key="Less than $30,000"
                      disabled={data.value !== "Tier-1 Less than $30,000"}
                    >
                      Tier-1 Less than $30,000
                    </option>
                    <option
                      value="Tier-2 $30,000 - $100,000"
                      key="$30,000-$100,000"
                      disabled={data.value === "Tier-3 Greater than $100,000"}
                    >
                      Tier-2 $30,000 - $100,000
                    </option>
                    <option
                      value="Tier-3 Greater than $100,000"
                      key="Greater than $100,000"
                    >
                      Tier-3 Greater than $100,000
                    </option>
                  </select>
                </>
              )}
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="primary" onClick={() => handleCancel()}>
              Cancel
            </Button>
            <Button type="click" variant="primary" onClick={() => submit()}>
              Submit
            </Button>
          </Modal.Footer>
        </>
      ) : (
        <>
          <Modal.Header closeButton>Update Account Usage</Modal.Header>
          <Modal.Body className="my-4 text-center">
            <h1 className="text-success text-bold display-3">
              <BsCheckCircleFill />
            </h1>
            <h5>Your request has been submitted</h5>
            <p className="my-3">
              <span className="text-danger text-bold">*</span>Please mail your
              documents at{" "}
              <a href="mailto:welcome@remitassure.com" target="_blank">
                welcome@remitassure.com
              </a>{" "}
              to update your account usage successfully.{" "}
            </p>
          </Modal.Body>
        </>
      )}
    </>
  );
};

export default Profile;
